export var EnvVars;
(function (EnvVars) {
    EnvVars["awsRole"] = "AWS_ROLE";
    EnvVars["environment"] = "ENVIRONMENT";
    EnvVars["uploadBucket"] = "UPLOAD_BUCKET";
    EnvVars["logAWSRequests"] = "AWS_LOG_REQUESTS";
    EnvVars["logTests"] = "LOG_TESTS";
})(EnvVars || (EnvVars = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW52VmFycy5qcyIsInNvdXJjZVJvb3QiOiJzcmMvIiwic291cmNlcyI6WyJjb25zdGFudHMvZW52VmFycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQU4sSUFBWSxPQU1YO0FBTkQsV0FBWSxPQUFPO0lBQ2pCLCtCQUFvQixDQUFBO0lBQ3BCLHNDQUEyQixDQUFBO0lBQzNCLHlDQUE4QixDQUFBO0lBQzlCLDhDQUFtQyxDQUFBO0lBQ25DLGlDQUFzQixDQUFBO0FBQ3hCLENBQUMsRUFOVyxPQUFPLEtBQVAsT0FBTyxRQU1sQiJ9